import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ContractInboundMail extends Resource {
    public override type = 'contractInboundMails';

    @prop()
    @required()
    public contractId!: string;

    @prop()
    @required()
    public mail!: string;
}